(function() {
    'use strict';

    angular.module('allegro').controller(
        'AllegroConfigurationCreateController', AllegroConfigurationCreateController);

    AllegroConfigurationCreateController.$inject = [
        '$state',
        'notificationSrvc',
        'errorNotificationSrvc',
        'allegroConfigDataSrvc',
        'allegroConfigMessagesConst'
    ];

    function AllegroConfigurationCreateController(
        $state, notificationSrvc, errorNotificationSrvc, allegroConfigDataSrvc, allegroConfigMessagesConst
    ) {
        var self = this;

        self.serverErrors = {
            client_id: [],
            client_secret: [],
            base_url: [],
            base_api_url: [],
            non_field_errors: []
        };

        self.configurationData = {
            client_id: '',
            client_secret: '',
            base_url: '',
            base_api_url: '',
        };

        self.createConfiguration = createConfiguration;
        self.cleanErrors = cleanErrors;

        function createConfiguration() {
            allegroConfigDataSrvc.create(self.configurationData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", allegroConfigMessagesConst.add);
                    $state.go('layout.allegro-configurations.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
